import React from 'react';
import { Button } from '@ui/button';
import { useReferralRef, CONFIRMATION_ZONE } from '../../referral';
import { ButtonWrap } from './appStyles';

export const Referral = () => {
  const rafRef = useReferralRef(CONFIRMATION_ZONE);
  return (
    <ButtonWrap>
      <Button ref={rafRef} variant="dark">
        {`Refer a friend`}
      </Button>
    </ButtonWrap>
  );
};
